import React, { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';

import { campaignType, fetchCampaignContext } from '~/services/registration';

import { ProgressBar } from '../ProgressBar';
import { contactPreferenceCopy } from '~/shared/config';
import {
    Container,
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Row,
    Form,
    CardFooter,
} from 'reactstrap';

import { Loading } from '../../../shared/components/Loading';

import { RegistrationContext } from '../../../context/registration';

const campaignTypeOptions = [
    {
        label: 'Transplant',
        value: 'transplant',
        description:
            'Heart, kidney, lung, double lung, liver, pancreas, multi-visceral, cell, LVAD, and bone marrow transplant',
        id: 2,
    },
    {
        label: 'Catastrophic Injury',
        value: 'cat-injury',
        description:
            'Spinal cord injury, traumatic brain injury, amputation, or multiple trauma',
        id: 3,
    },
    {
        label: 'Catastrophic Illness',
        value: 'cat-illness',
        description:
            'Cancer, coronavirus (COVID-19), multiple sclerosis, spina bifida, cerebral palsy, muscular dystrophy, transverse myelitis, stroke, or ALS and more',
        id: 4,
    },
];

const otherCampaignTypeOption = {
    label: 'Other',
    value: 'other',
    description: `Don't see your medical reason listed? You may still be eligible to benefit from a Help Hope Live campaign or other services we offer.`,
    id: 6,
};

export const CampaignType = ({}: any) => {
    const [{ campaign, campaignRequest, patient }, registrationDispatch] =
        useContext(RegistrationContext);
    const [loading, setLoading] = useState<boolean>(true);
    const [saving, setSaving] = useState<boolean>(false);
    const [isSelfCampaign, setIsSelfCampaign] = useState<boolean>(true);
    const [selectedType, setSelectedType] = useState();
    const { addToast } = useToasts();
    const history = useHistory();

    const getCampaign = async () => {
        const resp = await fetchCampaignContext();
        console.log('resp: ', resp);

        if (resp['detail']) {
            history.push('/login');
        } else {
            registrationDispatch({
                type: 'set_registration',
                payload: resp,
            });

            setLoading(false);
        }
    };

    // turn this off to work on it
    useEffect(() => {
        if (!campaign || !campaignRequest) {
            console.log('campaign: ', campaign);
            getCampaign();
        } else {
            if (campaignRequest) {
                setIsSelfCampaign(campaignRequest.campaign_is_for === 1);
                setLoading(false);
            }
        }
    }, [campaign, campaignRequest]);

    const campaignTypeOption = (type, i, isOther) => {
        return (
            <Col key={i} lg className='my-3'>
                <Card
                    className={`box-shadow ${
                        isOther
                            ? 'text-center text-lg-start'
                            : 'text-center h-100'
                    }`}
                    style={{
                        // height: isOther ? '120px' : '250px',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        border:
                            selectedType?.id === type.id
                                ? `3px solid #01aeb4`
                                : 'none',
                        background:
                            selectedType?.id === type.id
                                ? `rgba(1, 174, 180, 0.25)`
                                : 'none',
                    }}
                    key={i}
                >
                    <CardBody>
                        {isOther ? (
                            <Row className='align-items-center'>
                                <Col lg={10}>
                                    <CardTitle className='h4'>
                                        {type.label}
                                    </CardTitle>
                                    {type.description}
                                </Col>
                                <Col className='text-lg-end'>
                                    <Button
                                        color='link'
                                        className='stretched-link px-0'
                                        onClick={() => setSelectedType(type)}
                                    >
                                        {selectedType?.id === type.id
                                            ? 'Unselect'
                                            : 'Select'}
                                    </Button>
                                </Col>
                            </Row>
                        ) : (
                            <div>
                                <CardTitle className='h4'>
                                    {type.label}
                                </CardTitle>
                                <Row className='align-items-center'>
                                    {' '}
                                    {type.description}{' '}
                                </Row>
                            </div>
                        )}
                    </CardBody>
                    {!isOther && (
                        <CardFooter className='pt-0'>
                            <Button
                                color='link'
                                className='stretched-link px-0'
                                onClick={() => setSelectedType(type)}
                            >
                                {selectedType?.id === type.id
                                    ? 'Unselect'
                                    : 'Select'}
                            </Button>
                        </CardFooter>
                    )}
                </Card>
            </Col>
        );
    };

    const handleNext = async () => {
        try {
            setSaving(true);
            const resp = await campaignType(selectedType.id);
            console.log('resp: ', resp);

            registrationDispatch({
                type: 'set_campaign',
                campaign: resp,
            });

            if (selectedType.value === 'other') {
                history.push('/get-started/contact-preference', {
                    copy: contactPreferenceCopy.default,
                });
            } else {
                history.push('/get-started/condition/when');
            }
        } catch (e) {
            console.log('e: ', e);
        }
    };
    // turn this off, too
    if (loading) {
        return <Loading />;
    }

    const title = isSelfCampaign
        ? `Tell us about your medical reason for fundraising`
        : `Tell us about ${patient.person.first_name}'s medical reason for fundraising`;

    return (
        <Container className='w-100'>
            <ProgressBar selectedStep='patient' />

            <Row className='justify-content-center py-5'>
                <Col md='9'>
                    <div className='text-center'>
                        <h3>{title}</h3>
                    </div>

                    <Form>
                        <Row>
                            {campaignTypeOptions.map((type, i) => {
                                return campaignTypeOption(type, i, false);
                            })}
                        </Row>
                        <Row>
                            {campaignTypeOption(
                                otherCampaignTypeOption,
                                null,
                                true
                            )}
                        </Row>
                        <div className='text-center mt-5'>
                            <Button
                                color='outline-dark'
                                disabled={saving}
                                onClick={() => history.push('/get-started/who')}
                            >
                                Back
                            </Button>
                            <Button
                                color='primary'
                                disabled={!selectedType || saving}
                                onClick={handleNext}
                            >
                                {saving ? `Saving` : `Next`}
                            </Button>
                        </div>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
};
